/**
 * Parse API/store rim/hub value (`wheel_rim_diam`, `mmm_hub1`, …) to a finite number, or `null`.
 */
export function parseWheelRimDiam(
  wheelRimDiam: string | number | null | undefined,
): number | null {
  if (wheelRimDiam === null || wheelRimDiam === undefined) return null;
  const trimmed = String(wheelRimDiam).trim();
  if (trimmed === "") return null;
  const n = Number(trimmed);
  return Number.isFinite(n) ? n : null;
}

/**
 * Rim diameter / inch for UI: numeric string when parseable, otherwise empty string.
 * Use for `wheel_rim_diam`, `mmm_hub1`, etc.
 */
export function formatWheelRimDiamDisplay(
  value: string | number | null | undefined,
): string {
  const n = parseWheelRimDiam(value);
  return n !== null ? String(n) : "";
}
